module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/7bedcb37cdfb8a8c1615fc656a1176c2.png";